import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import Home from './pages/home';
import Contact from './pages/contact';
import About from './pages/about';
import Services from './pages/services';
import Header from './components/header';
import Footer from './components/footer';
import ScrollToTop from './common/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Suspense fallback={<CircularProgress />}>
        <Routes>
          <Route path="" element={<Home />} />
          <Route path="contact" element={<Contact />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
        </Routes>
        <Footer />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
